import { GutterOptions } from '@ryusei/code';


/**
 * The default options for the Gutter component.
 *
 * @since 0.1.0
 */
export const DEFAULT_OPTIONS: GutterOptions = {
  selectLine: true,
  start     : 1,
  sticky    : true,
};
